document.addEventListener('DOMContentLoaded', function () {
    const snowContainer = document.getElementById('snow-container');
    // Generar 50 copos de nieve dinámicamente
    for (let i = 0; i < 50; i++) {
        const snowflake = document.createElement('span');
        snowflake.classList.add('snowflake');
        snowflake.textContent = '❄';
        snowflake.style.left = Math.random() * 100 + 'vw'; // Posición aleatoria en el ancho
        snowflake.style.animationDuration = Math.random() * 5 + 5 + 's'; // Duración aleatoria
        snowflake.style.opacity = Math.random(); // Transparencia aleatoria
        snowflake.style.fontSize = Math.random() * 10 + 10 + 'px'; // Tamaño aleatorio
        snowflake.style.setProperty('--direction', Math.random() > 0.5 ? '1' : '-1'); // Dirección aleatoria
        snowContainer.appendChild(snowflake);
    }
});
